import { createDecorator } from '../../instantiation/common/instantiation.js';
const IUriIdentityService = ( createDecorator('IUriIdentityService'));
export { IUriIdentityService };
